/**============================================================
*   [Class] トップページメインスライダー
============================================================*/
export default class ArchiveTopMainSlider {
  constructor(
    target,
    key,
    targetClass
  )
  {

    //main slide
    this.swiperSlide = document.querySelectorAll(`${targetClass}`)[key].querySelector('.p-archive-top-main-slider');

    //thumb slide
    this.swiperThumbSlide = document.querySelectorAll(`${targetClass}`)[key].querySelector('.p-archive-top-around-slider');
    this.swiperThumbSlide.classList.add('swiper-archive-top-around-'+ this.swiperKey);

    let swiperSlides = this.swiperSlide.getElementsByClassName('swiper-slide');

    this.swiperKey = key;
    this.swiperSlideItemNum = swiperSlides.length * 3;
    this.swiperSlide.classList.remove('swiper-disabled');
    this.swiperSlide.classList.add('swiper-archive-top-main-'+ this.swiperKey);
    this.swiperThumbSlide.classList.add('swiper-archive-top-around-'+ this.swiperKey);

    this.initSwiper = () => {
      //サムネイルスライド
      this.swiperThumbnail = new Swiper(this.swiperThumbSlide, {
        loop: true,
        slidesPerView: 1,
        freeMode: true,
        watchSlidesProgress: true,//スライダーの動きにスライドを追従させる
        loopAdditionalSlides: this.swiperSlideItemNum,
        loopPreventsSlide: true,
        loopedSlides: 0,
        speed: 2400,
        followFinger: false,
        slidesPerGroup: 1,
        loopFillGroupWithBlank: true,
      });

      //メインスライド
      this.mySwiper = new Swiper(this.swiperSlide, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        loopAdditionalSlides: this.swiperSlideItemNum,
        loopPreventsSlide: true,
        speed: 1000,
        autoplay: {
          delay: 6000,
          disableOnInteraction: false,
          waitForTransition: false,
        },
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        autoHeight: true,
        pagination: {
            el: '.swiper-archive-top-main-'+ key + ' + .swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        navigation: {
          nextEl: '.swiper-archive-top-main-'+ key + ' .p-nav-swiper-container .swiper-button-next',
          prevEl: '.swiper-archive-top-main-'+ key + ' .p-nav-swiper-container .swiper-button-prev',
        },
        observeParents: true,
        thumbs: {
          swiper: this.swiperThumbnail, //連動したいスライダー（swiperThumbnailを指定する）
        },
      });
    };

    //SP用パラメータ（breakpointではfadeの切り替えができないため、設定しなおし）
    var paramsSp = {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      loopAdditionalSlides: this.swiperSlideItemNum,
      loopPreventsSlide: true,
      speed: 800,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
        waitForTransition: false,
      },
      autoHeight: true,
      pagination: {
          el: '.swiper-archive-top-main-'+ key + ' + .swiper-pagination',
          type: 'bullets',
          clickable: true
      },
      navigation: {
        nextEl: '.swiper-archive-top-main-'+ key + ' .p-nav-swiper-container .swiper-button-next',
        prevEl: '.swiper-archive-top-main-'+ key + ' .p-nav-swiper-container .swiper-button-prev',
      },
      observeParents: true,
      thumbs: {
        swiper: this.swiperThumbnail, //連動したいスライダー（swiperThumbnailを指定する）
      },
    };

    var mql = window.matchMedia('screen and (max-width: 979px)');
    const slider = (mql) => {
      if(this.mySwiper) this.mySwiper.destroy(true, true);
      if (mql.matches) {
        this.mySwiper = new Swiper(this.swiperSlide, paramsSp);
      } else {
        this.initSwiper();
      }
    }
    slider(mql);
    mql.addEventListener('change', slider, false);

  }
}
